if (!customElements.get("collection-list")) {
  class CollectionList extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.selectors = {
        sliderWrapper: ".collection-list__items",
        pagination: ".swiper-pagination",
        nextEl: ".swiper-btn-next",
        prevEl: ".swiper-btn-prev",
      };
      this.classes = {
        grid: "f-grid",
        swiper: "swiper",
        swiperWrapper: "swiper-wrapper",
      };

      this.sectionId = this.dataset.sectionId;
      this.section = this.closest(`.section-${this.sectionId}`);
      this.sliderWrapper = this.querySelector(this.selectors.sliderWrapper);
      this.sliderPagination = this.parentElement.querySelector(
        this.selectors.pagination
      );
      this.enableSlider = this.dataset.enableSlider === "true";
      this.items = parseInt(this.dataset.items);
      this.tabletItems = parseInt(this.dataset.tabletItems);
      this.mobileItems = parseInt(this.dataset.mobileItems || "1");

      this.sliderInstance = false;
      this.enableSwipeMobile = this.classList.contains("swipe-mobile");

      if (!this.enableSlider || !this.enableSwipeMobile) return;

      this.init();
      document.addEventListener("matchMobile", () => {
        this.handleViewportChange();
      });
      document.addEventListener("unmatchMobile", () => {
        this.handleViewportChange();
      });
    }

    init() {
      if (this.enableSlider) {
        this.initSlider();
        return;
      }

      if (FoxTheme.config.mqlMobile) {
        this.destroySlider();
        if (this.enableSwipeMobile) {
          this.initSlider();
        }
      }
    }

    initSlider() {
      const columnGap = FoxTheme.utils.getGridColumnGap(this.sliderWrapper);

      const sliderOptions = {
        slidesPerView: Number.isFinite(this.mobileItems)
          ? this.mobileItems
          : this.tabletItems > 3
          ? 3
          : parseInt(this.tabletItems),
        slidesPerGroup: 1,
        spaceBetween: columnGap.mobile,
        navigation: {
          nextEl: this.section.querySelector(this.selectors.nextEl),
          prevEl: this.section.querySelector(this.selectors.prevEl),
        },
        pagination: {
          el: this.sliderPagination,
          clickable: true,
        },
        breakpoints: {
          768: {
            slidesPerView:
              this.tabletItems > 2 ? 2 : parseInt(this.tabletItems),
            spaceBetween: columnGap.tablet,
          },
          1024: {
            slidesPerView: this.tabletItems > 2 ? 2 : parseInt(this.tabletItems),
            spaceBetween: columnGap.tabletLarge,
          },
          1280: {
            slidesPerView: parseInt(this.items),
            spaceBetween: columnGap.desktop,
          },
        },
        loop: true,
        threshold: 2,
        grabCursor: true,
        allowTouchMove: true,
        simulateTouch: true,
        touchRatio: 1,
        touchAngle: 45,
        longSwipes: true,
        longSwipesRatio: 0.5,
        longSwipesMs: 300,
        followFinger: true,
        speed: 400,
        preventInteractionOnTransition: false,
        observer: true,
        observeParents: true,
        on: {
          init: this.handleSliderInit.bind(this),
          transitionEnd: this.handleTransitionEnd.bind(this),
        },
      };
      if (typeof this.sliderInstance !== "object") {
        this.classList.add(this.classes.swiper);
        if (!this.sliderWrapper.classList.contains("dynamic")) {
          this.sliderWrapper.classList.remove(this.classes.grid);
        }
        this.sliderWrapper.classList.add(this.classes.swiperWrapper);
        this.sliderInstance = new window.FoxTheme.Carousel(this, sliderOptions);
        this.sliderInstance.init();

        const focusableElements = FoxTheme.a11y.getFocusableElements(this);

        focusableElements.forEach((element) => {
          element.addEventListener("focusin", () => {
            const slide = element.closest(".swiper-slide");
            this.sliderInstance.slider.slideTo(
              this.sliderInstance.slider.slides.indexOf(slide)
            );
          });
        });
      }

      if (Shopify.designMode && typeof this.sliderInstance === "object") {
        document.addEventListener("shopify:block:select", (e) => {
          if (e.detail.sectionId != this.sectionId) return;
          let { target } = e;
          const index = Number(target.dataset.index);

          this.sliderInstance.slider.slideToLoop(index);
        });
      }
    }

    handleViewportChange() {
      if (this.enableSlider) {
        this.destroySlider();
        this.initSlider();
        return;
      }
      this.init();
    }

    handleSliderInit() {
      if (this.sliderPagination) {
        const activeBullet = this.sliderPagination.querySelector(
          ".swiper-pagination-bullet-active"
        );

        if (activeBullet) {
          activeBullet.classList.remove("swiper-pagination-bullet-active");
          activeBullet.offsetHeight; // Trigger reflow.
          activeBullet.classList.add("swiper-pagination-bullet-active");
        }
      }
    }

    handleTransitionEnd() {
      // Fix any layout issues after transition
      if (this.sliderInstance && this.sliderInstance.slider) {
        this.sliderInstance.slider.update();
      }
    }

    destroySlider() {
      this.classList.remove(this.classes.swiper);
      this.sliderWrapper.classList.remove(this.classes.swiperWrapper);
      if (!this.sliderWrapper.classList.contains("dynamic")) {
        this.sliderWrapper.classList.add(this.classes.grid);
      }
      if (typeof this.sliderInstance === "object") {
        this.sliderInstance.slider.destroy();
        this.sliderInstance = false;
      }
    }
  }
  customElements.define("collection-list", CollectionList);
}
